import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * GET `/srm/purchase-order/{id}/payment-plan`。目前有效付款計畫（不含付款紀錄）。
 * 404＝採購單不存在或舊單尚未建立計畫，不可推定已付／未付。
 */
export async function fetchPurchaseOrderPaymentPlan(id) {
  const { data: raw } = await request.get(`/srm/purchase-order/${id}/payment-plan`);
  return parseVer4DetailResponse(raw);
}
